module.exports = __webpack_public_path__ + "img/34_7.2969260a.png";